import merge from 'lodash/merge';
import {forwardRef} from 'react';
import {getValidChildren} from '../../../common/shared/utils/getValidChildren';
import {twMerge} from '../../../common/twMerge';
import {ListProps} from './ListProps.interface';

const List = forwardRef<HTMLUListElement, ListProps>(
  (
    {
      children,
      direction = 'row',
      gapPx = 1,
      backgroundColor = 'transparent',
      className,
      style,
      listItemClassName,
      innerLeftPaddingPx,
      innerRightPaddingPx,
      ...props
    },
    ref
  ) => {
    return (
      <ul
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className={twMerge(
          !!innerLeftPaddingPx && 'list-inner-left-padding',
          !!innerRightPaddingPx && 'list-inner-right-padding',
          'flex',
          className
        )}
        ref={ref}
        style={merge(
          {
            flexDirection: direction,
            backgroundColor,
          },
          style
        )}
        {...props}
      >
        {getValidChildren(children).map((child, idx) => (
          <li
            key={idx}
            // eslint-disable-next-line tailwindcss/no-custom-classname
            className={twMerge('list-child-item', listItemClassName)}
          >
            {child}
          </li>
        ))}
        {/*
         * 내부에 padding-left, right를 주게 되면 특정 브라우저에서 left는 들어가는데 right는 적용 안되는 현상이 있습니다.
         * 특정 브라우저에서 패딩이 아닌 컨텐츠 영역까지만 스크롤을 보여주기 때문입니다. 참고 https://alexandergottlieb.com/2018/02/22/overflow-scroll-and-the-right-padding-problem-a-css-only-solution/
         * 리스트 내부 첫번째 요소에 before 마지막 요소에 after css 가상요소로 변경했습니다.
         */}
        <style jsx>
          {`
            .list-inner-left-padding::before {
              content: '';
              flex-shrink: 0;
              width: ${innerLeftPaddingPx}px;
              height: 1px;
            }
            .list-inner-right-padding::after {
              content: '';
              flex-shrink: 0;
              width: ${innerRightPaddingPx}px;
              height: 1px;
            }
          `}
        </style>
        <style jsx>
          {`
            .list-child-item:not(:last-child) {
              ${
                direction === 'row'
                  ? `margin-right: ${gapPx}px;`
                  : `margin-bottom: ${gapPx}px;`
              }
            }
          `}
        </style>
      </ul>
    );
  }
);

List.displayName = 'List';

export {List};
